import { AfterViewInit, Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

/*
 * Parent must have a fixed width for this directive to work properly.
 * Ellipsis will not appear without a parent width.
 *
 * tooltipText: @Input overrides the element's innerHtml with the provided
 *  string variable in the title, used to prevent HTML tags from appearing
 *  in the mouseover title. This will override text from an Input node.
 */
@Directive({
    selector: '[ellipsis]',
})
export class EllipsisDirective implements AfterViewInit {
    @Input() public tooltipText: string;

    private element: HTMLElement;

    public constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

    public ngAfterViewInit(): void {
        this.element = this.elementRef.nativeElement;
        this.renderer.setStyle(this.element, 'display', 'block');
        this.renderer.setStyle(this.element, 'overflow', 'hidden');
        this.renderer.setStyle(this.element, 'textOverflow', 'ellipsis');
        this.renderer.setStyle(this.element, 'whiteSpace', 'nowrap');
    }

    @HostListener('mouseenter') public enter(): void {
        if (this.element.offsetWidth < this.element.scrollWidth) {
            if (this.tooltipText !== undefined && this.tooltipText.length > 0) {
                this.element.title = this.tooltipText;
                return;
            } else if (this.element.nodeName === 'INPUT') {
                this.element.title = this.elementRef?.nativeElement?.value;
                return;
            }

            this.element.title = this.element.innerHTML;
        }
    }
}
